import { useLazyQuery, useMutation } from "@apollo/client";
import { onErrorGraphql } from "utils/onErrorGraphql";
import { clientNeoFact } from "@neonumy/api-clients";
import { FormInstance } from "antd";
import {
  CREATE_CLIENT_VAT_TYPE,
  DELETE_CLIENT_VAT_TYPE,
  GET_CLIENT_VAT_TYPE,
  LIST_CLIENT_VAT_TYPES,
  UPDATE_CLIENT_VAT_TYPE,
} from "queries/neoFact/clientVatTypes";
import { useEffect } from "react";

export default function useClientVatTypesApi(id?: ID, form?: FormInstance<any>) {
  const [
    listClientVatTypes,
    {
      refetch: refetchListClientVatTypes,
      loading: loadingListClientVatTypes,
      data: listClientVatTypesData,
      error: listClientVatTypesError,
    },
  ] = useLazyQuery<ListClientVatTypesResponse, ListClientVatTypesVars>(LIST_CLIENT_VAT_TYPES, {
    client: clientNeoFact,
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    if (listClientVatTypesError) onErrorGraphql(listClientVatTypesError);
  }, [listClientVatTypesError]);

  const clientsVatTypesData: ListClientVatTypesResults =
    listClientVatTypesData?.listClientVatTypes?.results?.map(item => ({
      ...item,
      key: item.id,
    })) ?? [];

  const clientVatTypesTotalCount = listClientVatTypesData?.listClientVatTypes?.totalCount ?? 0;

  const [createUpdateClientVatType, { loading: createUpdateClientVatTypeLoading }] = useMutation<
    CreateUpdateClientVatTypeMutationResponse,
    CreateClientVatTypeVars | UpdateClientVatTypeVars
  >(id ? UPDATE_CLIENT_VAT_TYPE : CREATE_CLIENT_VAT_TYPE, {
    client: clientNeoFact,
    fetchPolicy: "no-cache",
  });

  const [deleteClientVatType] = useMutation<DeleteClientVatTypeResponse, DeleteClientVatTypeVars>(
    DELETE_CLIENT_VAT_TYPE,
    {
      client: clientNeoFact,
      fetchPolicy: "no-cache",
    },
  );

  const [
    getClientVatType,
    { refetch: refetchClientVatType, data: getClientVatTypeData, error: getClientVatTypeError },
  ] = useLazyQuery<GetClientVatTypeResponse, GetVarTypeID>(GET_CLIENT_VAT_TYPE, {
    client: clientNeoFact,
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    if (getClientVatTypeError) onErrorGraphql(getClientVatTypeError);
  }, [getClientVatTypeError]);

  useEffect(() => {
    const getClientVatType = getClientVatTypeData?.getClientVatType;
    if (!getClientVatType) return;

    form?.setFields([
      { name: "name", value: getClientVatType?.name },
      { name: "code", value: getClientVatType?.code },
    ]);
  }, [getClientVatTypeData, form]);

  return {
    getClientVatType,
    listClientVatTypes,
    deleteClientVatType,
    clientsVatTypesData,
    refetchClientVatType,
    clientVatTypesTotalCount,
    createUpdateClientVatType,
    refetchListClientVatTypes,
    loadingListClientVatTypes,
    createUpdateClientVatTypeLoading,
  };
}
